module.exports = __webpack_public_path__ + "static/media/4ll26.46c0d00a.png";